import f3 from "assets/img/posts/f3.jpg";

const PostLink = () => {
    return (
        // <a href="#">
        <div className="post-link d-flex flex-col flex-a-start flex-j-center gap-10">
            {/* <!-- Link image --> */}
            <div className="link-image p-relative">
                <div className="link-media-overlay"></div>
                <img src={f3} alt="" />
            </div>
            {/* <!-- Link content --> */}
            <div className="link-content">
                <small>website.com</small>
                <h4>
                    <a href="#">Some heading here ?</a>
                </h4>
                <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Officia temporibus, illum sequi neque tempore repudiandae?.
                </p>
            </div>
            {/* <!-- Post actions --> */}
            {/* <!-- /partials/pages/feed/buttons/feed-post-actions.html --> */}
        </div>
        // </a>
    );
};

export default PostLink;
